// The constant must be the same as on the Back-End
export const DEFAULT_PRE_CALL_NOTIFICATION = 'This is a valid call';